import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDTypography from "../../components/MDTypography";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";

export default function EventNoteModal({note, show, saving, handleClose, handleSave}) {

  const [context, setContext] = useContext(AppContext);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(note)
  });

  const handleCloseNote = () => {
    handleClose();
  };


  const handleSaveNote = (data) => {
    handleSave(data);
  };

  const [reminderNote, setReminderNote] = useState(false);
  useEffect(()=>{
    if (note?.reminderNote) {
      setReminderNote(note?.reminderNote)
    }
  },[])

  return (
    <Modal onHide={handleCloseNote} size={'lg'} show={show}>
      <form
        onSubmit={handleSubmit(handleSaveNote)} id={'noteForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{note?.guid ? 'Edit' : 'Add'} Note</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <textarea required
                                rows={15}
                                {...register('note')}
                                className="form-control" id="note"
                                placeholder="Enter Note"/>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>

          <Row className={'mt-2'}>
            <Col className={'col'} sm={6} xs={12}>
              <MDTypography variant={'h6'}>
                <label><input type="checkbox"
                              role={'switch'}
                              id="reminderNote"
                              className={'form-check-input'}
                              name="reminderNote"
                              defaultChecked={note?.reminderNote}
                              {...register('reminderNote')}
                              onChange={(e) => {
                                setReminderNote(!reminderNote);
                              }}/>&nbsp;Reminder</label>
              </MDTypography>

              <MDTypography variant={'h6'} className={'mt-2'}>
                <label><input type="checkbox"
                              role={'switch'}
                              id="noteFlag"
                              className={'form-check-input'}
                              name="noteFlag"
                              defaultChecked={note?.noteFlag}
                              {...register('noteFlag')}
                              onChange={(e) => {
                                // toggleNoteFlag();
                              }}/>&nbsp;Flag Note</label>
              </MDTypography>

            </Col>
            <Col className={'col'} sm={6} xs={12}>
              <div className="form-group">
                <label htmlFor="reminderDate">Reminder Date</label>
                <div>
                  <DesktopDatePicker
                    slotProps={{
                      actionBar: {
                        actions: ['today'],
                      },
                    }}
                    value={dayjs(note?.reminderDate || new Date())}
                    disabled={!reminderNote}
                    onChange={(e) => {
                      setValue('reminderDate', new Date(e.$d))
                    }}
                  />
                </div>
              </div>
            </Col>
          </Row>


        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}